import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resetPassword } = useAuth();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Le mot de passe doit contenir au moins 8 caractères"); return; }
    if (pw !== pw2) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await resetPassword(token, pw);
      toast.success("Mot de passe mis à jour. Connectez-vous.");
      navigate("/connexion", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Lien invalide ou expiré");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-brand-softer flex flex-col items-center justify-center px-5" data-testid="reset-password-page">
      <div className="bg-white rounded-3xl border border-brand-soft p-8 max-w-md w-full">
        <h1 className="font-display text-2xl font-semibold text-brand-greenDeep">Nouveau mot de passe</h1>
        <p className="text-brand-green/60 mt-1 mb-6 text-sm">Choisissez un nouveau mot de passe pour votre compte.</p>
        {!token ? (
          <p className="text-sm text-red-600">Lien invalide. <Link to="/connexion" className="underline">Retour</Link></p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-brand-green/40" />
              <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Nouveau mot de passe" className="w-full pl-12 pr-4 py-3.5 rounded-2xl border border-brand-soft focus:border-brand-lime outline-none" data-testid="reset-pw1" />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-brand-green/40" />
              <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirmer le mot de passe" className="w-full pl-12 pr-4 py-3.5 rounded-2xl border border-brand-soft focus:border-brand-lime outline-none" data-testid="reset-pw2" />
            </div>
            <button type="submit" disabled={busy} className="group w-full flex items-center justify-center gap-2 py-3.5 rounded-full bg-brand-lime hover:bg-brand-limeDark text-brand-greenDeep font-semibold disabled:opacity-60" data-testid="reset-submit">
              {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Mettre à jour <ArrowRight className="w-5 h-5" /></>}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
